var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRequestConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_4440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 1.28564C1.34578 1.28564 0 2.43917 0 3.85707C0 4.80677 0.604219 5.63727 1.5 6.0826V13.203C0.604219 13.6483 0 14.4788 0 15.4285C0 16.8464 1.34578 17.9999 3 17.9999C4.65422 17.9999 6 16.8464 6 15.4285C6 14.4788 5.39578 13.6483 4.5 13.203V6.0826C5.39578 5.63727 6 4.80677 6 3.85707C6 2.43917 4.65422 1.28564 3 1.28564ZM3 16.7142C2.17158 16.7142 1.5 16.1386 1.5 15.4285C1.5 14.7184 2.17158 14.1428 3 14.1428C3.82842 14.1428 4.5 14.7184 4.5 15.4285C4.5 16.1386 3.82842 16.7142 3 16.7142ZM3 5.14279C2.17158 5.14279 1.5 4.56715 1.5 3.85707C1.5 3.147 2.17158 2.57136 3 2.57136C3.82842 2.57136 4.5 3.147 4.5 3.85707C4.5 4.56715 3.82842 5.14279 3 5.14279Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 13.1799V6.95045C16.4531 5.5849 15.9614 4.49948 14.9916 3.72435C13.9551 2.89595 12.4456 2.50341 10.5 2.55491V0L6 3.85714L10.5 7.71429V5.14286C11.7422 5.14286 12.5002 5.24901 12.9457 5.60507C13.2824 5.87419 13.4531 6.32684 13.4531 6.95045V13.2262C12.583 13.6769 12 14.4954 12 15.4285C12 16.8464 13.3458 18 15 18C16.6542 18 18 16.8464 18 15.4285C18 14.4623 17.3748 13.6193 16.4531 13.1799ZM15 16.7143C14.1716 16.7143 13.5 16.1386 13.5 15.4286C13.5 14.7185 14.1716 14.1429 15 14.1429C15.8284 14.1429 16.5 14.7185 16.5 15.4286C16.5 16.1386 15.8284 16.7143 15 16.7143Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_4440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRequestConnect);
export default __webpack_public_path__ + "static/media/ic_request_connect.37a136c349d66f11004ce9c74621fb81.svg";
export { ForwardRef as ReactComponent };